<template>
  <h3 class="h3">Für welchen Fahrzeugtyp möchtest du das Fahrsicherheitstraining durchführen?</h3>

  <div class="flex gap-[10px]">
    <div :class="['typebutton', classIsActiveas(FahrzeugTyp.A) ? 'active' : '']" @click="select(FahrzeugTyp.A)">
      <span class="text-slate-500 text-xl font-semibold">{{ FahrzeugTyp.A }}</span>
      <span class="text-slate-400">Motorad</span>
    </div>
    <div :class="['typebutton', classIsActiveas(FahrzeugTyp.B) ? 'active' : '']" @click="select(FahrzeugTyp.B)">
      <span class="text-slate-500 text-xl font-semibold">{{ FahrzeugTyp.B }}</span>
      <span class="text-slate-400">PKW</span>
    </div>
  </div>

  <div class="flex justify-between mt-5 items-center">
    <input type="button" class="button prev" :value="Navigation.ZURÜCK" @click="prev"/>
    <input type="button" class="button next" :disabled="nextDisabled" :value="Navigation.WEITER" @click="next"/>
  </div>
  <div class="text-center">
    <span class="!text-gray-200 !text-xs !font-sans">digital begeistert von <a href="https://www.codeandcomments.at" class="!underline !text-xs !text-gray-200 !font-sans">code & comments</a></span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { DetailStep, Navigation, FahrzeugTyp } from '../models/enums'
import { useStore } from 'vuex';
import { scrollToTop } from '@/models/helper';

const store = useStore();
const nextDisabled = computed(() => store.state.selectedVehicletype == null);
const selectedVehicletype = computed(() => store.state.selectedVehicletype);

const classIsActiveas = (type) => type == selectedVehicletype.value;
const select = (type) => { store.commit("updateVehicletype", type) };
const prev = () => {
  store.commit("stepBack");
  scrollToTop();
}
const next = () => {
  store.commit("updateStep", DetailStep.TERMIN_LEIHFAHRZEUG);
  scrollToTop();
}
</script>

<style scoped lang="scss">
.typebutton {
  @apply border border-slate-300 bg-gray-100 cursor-pointer p-4 flex flex-col rounded-md select-none w-36;
  &.active {
    @apply bg-gray-300;
  }
}
</style>